import { i as d, x as i, s as p } from "../../../lit-element-6iugfgmM.js";
import { e as c } from "../../../custom-element-wk-AooBb.js";
import "../../../query-assigned-elements-B8U94KLQ.js";
import "../../../sp-field-label-BwIfWLHz.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-sort-order-down.js";
import "../../../overlay-trigger-25h1jNVy.js";
import "../../../sp-popover-DFTTgsX0.js";
import "../../../sp-picker-X_cwvgPh.js";
import u from "../../../events/SortChangeEvent.js";
import { Localize as f } from "../../../lib/I18N.js";
const m = { "font-sorter.sort-label": "Sort" }, h = d`:host{--mod-picker-border-color-default: var(--spectrum-gray-200)}[part=default-view]{display:none}div,sp-action-button{display:flex;flex-direction:column}`;
var v = Object.defineProperty, b = Object.getOwnPropertyDescriptor;
let a = class extends f(p, m) {
  static get styles() {
    return h;
  }
  get options() {
    return [...this.querySelectorAll("option")].map((t) => ({ label: t.innerText, selected: t.hasAttribute("selected"), value: t.getAttribute("value") }));
  }
  get defaultSelectedOption() {
    return this.options.find((t) => t.selected) || this.options[0];
  }
  render() {
    return i`${this.renderMobileFontSorter()} ${this.renderFontSorter()}`;
  }
  renderMobileFontSorter() {
    return i`<div class="sort-fonts-container" part="compact-view"><sp-field-label for="sort-fonts">${this.t("font-sorter.sort-label")}</sp-field-label><sp-action-menu label="${this.t("font-sorter.sort-label")}" quiet selects="single" value="${this.defaultSelectedOption.value}"><sp-icon-sort-order-down slot="icon"></sp-icon-sort-order-down>${this.renderFontSorterOptions()}</sp-action-menu></div>`;
  }
  renderFontSorter() {
    return i`<div class="sort-fonts-container" part="default-view"><sp-field-label for="sort-fonts">${this.t("font-sorter.sort-label")}</sp-field-label><sp-picker id="sort-fonts" label="${this.t("font-sorter.sort-label")}" .value="${this.defaultSelectedOption.value}">${this.renderFontSorterOptions()}</sp-picker></div>`;
  }
  renderFontSorterOptions() {
    return this.options.map(({ label: t, selected: e, value: o }) => i`<sp-menu-item aria-checked="${e}" aria-selected="${e}" ?selected="${e}" value="${o}" @click="${this.handleSortSelection}">${t}</sp-menu-item>`);
  }
  handleSortSelection(t) {
    const e = t.target.value;
    this.dispatchEvent(new u(e));
  }
};
a = ((t, e, o, s) => {
  for (var l, r = s > 1 ? void 0 : s ? b(e, o) : e, n = t.length - 1; n >= 0; n--) (l = t[n]) && (r = (s ? l(e, o, r) : l(r)) || r);
  return s && r && v(e, o, r), r;
})([c("af-font-sorter")], a);
const j = a;
export {
  j as default
};
//# sourceMappingURL=FontSorter.js.map
